var _style, _defs, _defs2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _defs3, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1417.3 1417.3",
    style: {
      enableBackground: "new 0 0 1417.3 1417.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000091726573171955751340000002384643194097142696_);}\n\t.st1{clip-path:url(#SVGID_00000081617345634306129420000005496378860643062717_);}\n\t.st2{fill:#CEAE9F;}\n\t.st3{fill:#B78E7E;}\n\t.st4{fill:#8C6154;}\n\t.st5{fill:#FBCD9D;}\n\t.st6{fill:#F6AC87;}\n\t.st7{fill:#FFEEA8;}\n\t.st8{fill:#F9D68F;}\n\t.st9{fill:#7EA9C1;}\n\t.st10{fill:#5889A0;}\n\t.st11{fill:#E1F2FC;}\n\t.st12{fill:#4E5C64;}\n\t.st13{fill:#374449;}\n\t.st14{fill:#BEE2EF;}\n\t.st15{opacity:0.5;}\n\t.st16{clip-path:url(#SVGID_00000028324029675371843660000013065496564476176035_);}\n\t.st17{fill:#D25443;}\n\t.st18{fill:#563528;}\n\t.st19{fill:#FFF2D7;}\n\t.st20{fill:#543432;}\n\t.st21{fill:#EF8E6E;}\n\t.st22{fill:#543732;}\n\t.st23{fill:#E25959;}\n\t.st24{fill:#95ACB6;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 449.8,
    y: 206.6,
    width: 517.2,
    height: 1004.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070806489883193006590000005966212260264347792_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3081",
    style: {
      clipPath: "url(#SVGID_00000070806489883193006590000005966212260264347792_)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3080"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000115489982878753780170000015163311357235314322_",
    x: 449.8,
    y: 206.6,
    width: 517.2,
    height: 1004.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181798962530076233320000013185156987051673009_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000115489982878753780170000015163311357235314322_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3079",
    style: {
      clipPath: "url(#SVGID_00000181798962530076233320000013185156987051673009_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20812",
    className: "st2",
    d: "M675.9,532.2c-33.1,5-74.4-14.2-54.9-61.3c-16.6-8.6-24.1-28.3-17.4-45.8 c10.6-32.2,27.5-34,27.5-34s-33.8-20.9-16-52.4s65.4-33.7,65.4-33.7s-5.3-24.4,23.6-29.3c28.8-4.9,48,32.9,48,32.9 s21.7-15,42.5,17.4s3.7,44.9,3.7,44.9s39.9,12.4,33.5,46c-6.4,33.7-17.9,36-17.9,36s23.1,16.7-2.4,48.3s-62.7-1.5-62.7-1.5 C727.4,516.4,702.4,527.6,675.9,532.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20813",
    className: "st3",
    d: "M831.7,417c6.4-33.7-33.5-46-33.5-46c1.4-1.2,2.6-2.5,3.5-4.1 c-22.3,13-93.6,28.8-131.6,24.7c-40.9-4.4-38.8-29.4-57-48.8c-13,29.3,18,48.4,18,48.4s-16.8,1.8-27.5,34 c-6.7,17.5,0.8,37.2,17.4,45.8c-19.5,47.1,21.8,66.3,54.9,61.3c26.6-4.6,51.6-15.8,72.8-32.4c0,0,37.1,33.2,62.7,1.5 c25.5-31.6,2.4-48.3,2.4-48.3S825.3,450.6,831.7,417"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20814",
    className: "st4",
    d: "M675.9,532.2c26.6-4.6,51.6-15.8,72.8-32.4c0,0,28.5,25.5,52.7,10.5 c0.1-1.6-33-99.6-73.7-99.6c-40.8,0-72.8,113.2-70.7,121.8C663.2,533.2,669.6,533.1,675.9,532.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20815",
    className: "st5",
    d: "M565.2,628.7c17-26.9,111.4-120,136.3-118.9c25,1.1-13.2,51.9-13.2,51.9 s-85.6,81.3-95.3,85.2C583.3,650.7,555.5,644,565.2,628.7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20816",
    className: "st6",
    d: "M701.5,509.7c-16.6-0.7-63.9,40.2-98.7,75.6c5.1-1.3,9.4-0.9,12.2,1.6 c8.1,7.3,0,29.4-18.1,49.4c-3.7,4.1-7.7,8-12,11.5c2.8,0.2,5.5-0.2,8.1-1.1c9.7-3.9,95.3-85.1,95.3-85.1 S726.5,510.8,701.5,509.7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20817",
    className: "st5",
    d: "M879.3,401.5c-6.5,31.1-62.4,151.3-86.2,159c-23.8,7.7-9.4-63.9-9.4-63.9 s55.5-95.4,63.2-102.4C854.6,387.1,883,383.8,879.3,401.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20818",
    className: "st6",
    d: "M872.4,415.1c-14.4,29.2-33,49.5-41.4,45.3c-8.2-4.1-3.7-30.1,10.1-58.6 c-16.4,24.2-57.5,94.8-57.5,94.8s-14.3,71.7,9.4,63.9c23.8-7.7,79.7-127.9,86.2-159c0.2-0.9,0.3-1.9,0.3-2.9 C877.6,404,875.1,409.5,872.4,415.1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20819",
    className: "st5",
    d: "M597,641.9c-10.9-13.9-18.1-21.6-30.2-15.5c-19.6,18.5-55.7,106.3-63.4,121l4.7,6.6 C508.4,753.8,585.8,673.3,597,641.9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20820",
    className: "st6",
    d: "M504.3,748.7l3.8,5.4c0.3-0.3,85.9-84.2,97.1-115.6c-0.9-1.1-10,1.2-10.8,0.1 C575.4,671.5,520.5,731.3,504.3,748.7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20821",
    className: "st5",
    d: "M844.6,399.9c13.8,11.1,22.5,16.9,33,8.2c14.8-22.5,29.9-116.2,34-132.3l-6.1-5.4 C905.2,270.7,848.4,366.8,844.6,399.9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20822",
    className: "st5",
    d: "M829.6,717.5L668.2,744c-12.5,140.2-4.5,255.2,23.2,457.6h7.1 c1.9-29.9,49.2-342.5,49.2-342.5l18.7-0.5c20.9,46.1,119.1,343,119.1,343h10.7C869,959.3,829.6,717.5,829.6,717.5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20823",
    className: "st6",
    d: "M829.6,717.5L668.2,744c-7.2,79.6-7.6,159.6-1.3,239.3c20.3,1.4,39.7,21.6,54.4,53.3 c12.9-87.8,26.4-177.4,26.4-177.4l18.7-0.5c9.3,20.6,34.1,91.2,58.6,163c6.4-16.6,16-27.6,28.4-30.3c5.6-1.1,11.4-0.7,16.7,1.3 C849.1,837.3,829.6,717.5,829.6,717.5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20824",
    className: "st7",
    d: "M652.6,933.7l96.5,8l7.1-69.7h7.1l28.6,80.4l85.7-23.2L838.4,747l-174.2,21L652.6,933.7 z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20825",
    className: "st8",
    d: "M786.4,861.8c-9.4,1.7-18.9,2.6-28.4,2.6c-6.4,0-12.7-0.4-19-1.2 c2.1,15.9,2.7,31.9,1.7,47.9c-0.5,10-1.6,19.9-3.2,29.7l11.6,1l7.1-69.7h7.1l28.6,80.4l7-1.9c-2.7-8.2-5.1-16.4-7-24.8 C786.9,904.8,785.1,883.3,786.4,861.8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20826",
    className: "st8",
    d: "M838.4,747l-174.2,21l-11.6,165.7l8.9,0.7c-0.6-10-0.6-19.9,0-29.9 c4.1-76.3,29.4-121.1,84.7-122.7c60.1-1.8,105.5,46,123.7,126.2c1.7,7.6,3,15,4,22.2l3.8-1L838.4,747z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20827",
    className: "st9",
    d: "M660.9,767.9c0,0,148.5,13,184-14.9c0,0-31.6-199.7-39.1-219.8 c-6.2-16.6-81.2-20-114.3-12.5C684.3,522.3,675,615,675,615S659.8,747.8,660.9,767.9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20828",
    className: "st10",
    d: "M748.2,663.5c41.9,0,80.9,48.7,86.7,95.2c3.6-1.5,7-3.4,10.1-5.7 c0,0-31.6-199.7-39.1-219.8c-6.2-16.6-81.2-20-114.3-12.5C684.3,522.3,675,615,675,615s-15.1,132.8-14.1,152.9 c0,0,3.2,0.3,8.7,0.7C671.2,718.4,703.3,663.5,748.2,663.5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20829",
    className: "st9",
    d: "M800.6,457l45,38.3c-10.5,24.6-27.5,45.8-49.2,61.3c-35.5,24.7-31.7-63.2-31.7-63.2 L800.6,457z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20830",
    className: "st10",
    d: "M829.9,481.9c-0.7,2.2-1.4,4.4-2.3,6.7c-10.3,25.7-29.8,41.9-43.7,36.4 c-10.7-4.3-22.9,56.3,12.5,31.6c21.7-15.5,38.8-36.7,49.2-61.3L829.9,481.9z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20831",
    className: "st9",
    d: "M642.3,609.8L616,566.2c0,0,39.7-46.4,80.8-55.3c41.1-8.9-12.5,75.8-12.5,75.8 L642.3,609.8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20832",
    className: "st10",
    d: "M696.8,510.9c-1.5,0.3-3,0.7-4.5,1.1c5.4,8.4-8.4,30.9-31.7,51.3 c-9.9,8.9-20.9,16.4-32.9,22.2l20.4,33.7l40.6-27.1C688.8,592.2,737.9,502,696.8,510.9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20833",
    className: "st9",
    d: "M666,638.5c1.2,13.1,142,14.6,157.7-5.7s-25.6-122.1-33.2-135.9S698.1,506.9,687,515 C676,523.2,665.1,627.9,666,638.5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20834",
    className: "st10",
    d: "M819.8,629.9c-14.5,20.5-148.8,19-150.3,5.8c-1-9.4,5-49.8,1.8-69.5 c-5,32-8.4,68.3-7.8,74.4c1.2,13.3,146.4,14.8,162.5-5.8c10.3-13.1-2.4-57.3-15.5-93C804.4,543.8,834.1,609.6,819.8,629.9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20835",
    className: "st11",
    d: "M737.9,534l-48.2-21.9c22.4-11.4,46.8-18.1,71.9-19.7L737.9,534z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20836",
    className: "st5",
    d: "M746.3,460.1L699,475.2l2.5,33.4l33.2,16.5l20-27.5L746.3,460.1z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20837",
    className: "st12",
    d: "M479.3,748.7c8.6-7.6,10.7-19.2,4.8-25.9c-5.9-6.7-17.7-5.9-26.2,1.7 c-8.6,7.6-10.7,19.2-4.8,25.9S470.8,756.2,479.3,748.7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20838",
    className: "st13",
    d: "M478.4,747c6.8-6,9.2-14.3,5.5-18.6c-3.8-4.2-12.3-2.8-19.1,3.2 c-6.8,6-9.2,14.3-5.5,18.6C463.1,754.4,471.6,753,478.4,747"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20839",
    className: "st13",
    d: "M516.6,792.8l7.8-6.5l-47.2-50.5l-7.8,6.5L516.6,792.8z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20840",
    className: "st12",
    d: "M517.3,793.6l7.9-6.4C505.4,765.6,482.6,754.7,517.3,793.6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20841",
    className: "st7",
    d: "M925.8,1210.9h-47.9c0,0,1.6-18,10.9-19.6C898.1,1189.7,925.9,1210.9,925.8,1210.9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20842",
    className: "st7",
    d: "M650.9,1210.9h55.3c0,0-1.9-18-12.6-19.6C682.9,1189.7,650.9,1210.9,650.9,1210.9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20843",
    className: "st8",
    d: "M717.4,853.1c0,0,50.9,8.4,88.9-2c0,0-21.4,14.8-43.8,16.1 C740.1,868.6,717.3,853.1,717.4,853.1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20844",
    className: "st11",
    d: "M646.8,622.4l8.9-3.6l-37.5-61.2l-7.6,6.7L646.8,622.4z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20845",
    className: "st14",
    d: "M633,581.9c-3,1.4-6.2,2.6-9.4,3.4l23.1,37.1l8.9-3.6L633,581.9z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20846",
    className: "st11",
    d: "M855.9,495.9l-4.5,8.7l-57.1-44.2l7.4-7.1L855.9,495.9z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20847",
    className: "st14",
    d: "M816.9,477.9c1.7-2.9,3.2-6,4.4-9.2l34.6,27.2l-4.5,8.7L816.9,477.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3078",
    transform: "translate(65.085 78.453)",
    className: "st15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3077"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000146497825847197998280000013519062472260712634_",
    x: 595,
    y: 381.6,
    width: 128.9,
    height: 95.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000061448075856099109050000006075862340699668406_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000146497825847197998280000013519062472260712634_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3076",
    style: {
      clipPath: "url(#SVGID_00000061448075856099109050000006075862340699668406_)"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20848",
    className: "st17",
    d: "M665.5,476.3c32.1-6.6,52.4-48,58.3-86l-24.3,24.6l0,0c-1.3,0.1-2.6,0.3-3.9,0.5 l0.8-1.4c-2.7,0.1-5.3,0.4-7.8,0.6l-7.5-33L634,396.7l2.4,31.5c-4,1.6-7.9,3.5-11.8,5.5l0.9,0.4 c-10.8,3.5-21.1,8.6-30.5,15C613.3,464.7,641.2,481.3,665.5,476.3"
  })))))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20849",
    className: "st5",
    d: "M665.2,441.5c3.4,20.6,28.5,60.8,63.2,54.6c32.7-5,43.8-47,41.5-67 c-6.2-29.2-12.1-76-36.9-78.2C708.2,348.7,649.8,347.3,665.2,441.5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20850",
    className: "st3",
    d: "M761,407c-5.4-6.4-17.9-15-32.6-5.4l0.9,5.3c0,0,11.5-11,30.8,1.4L761,407z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20851",
    className: "st3",
    d: "M669,416.4c3-7,12.1-17.6,29.8-12.5l1,4.9c0,0-15.1-7-29.4,8.5L669,416.4z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20852",
    className: "st18",
    d: "M734.7,461.2l-26.8,3.8c0,0,6.1,14.1,16.8,11.5C735.3,473.9,734.7,461.2,734.7,461.2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20853",
    className: "st6",
    d: "M717.9,483c-0.2-1.4,3.3-1.3,7.3-1.7c4-0.4,6.9-1.1,7.1,0.3c0.2,1.4-2.9,2.8-6.9,3.2 C721.5,485.3,718.1,484.5,717.9,483"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20854",
    className: "st19",
    d: "M733.6,462.3l-0.8,5.3l-18.7,4.3l-4.5-5.9L733.6,462.3z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20855",
    className: "st20",
    d: "M737.2,421.1c0-2.6,2.2-4.7,4.7-4.6c2.6,0,4.7,2.2,4.6,4.7c0,2.2-1.5,4-3.7,4.5 C740.1,426,737.5,424,737.2,421.1"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20856",
    className: "st6",
    d: "M754.7,427.3c-6,0.5-11.9,1.4-17.8,2.6l17.3,1.9L754.7,427.3z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20857",
    className: "st20",
    d: "M688.9,426.9c-0.5-2.8,1.2-5.4,3.9-6.1c2.4-0.2,4.6,2.2,4.8,5.3 c0.5,2.8-1.2,5.4-3.9,6.1C691.3,432.4,689.2,430,688.9,426.9"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20858",
    className: "st6",
    d: "M682.3,438.5c6.2-1.9,12.6-3.6,19-4.8l-16.7,8.7L682.3,438.5z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20859",
    className: "st21",
    d: "M726.2,448.3c-0.1,0.5-0.3,1-0.5,1.4c-3.3,3.1-8,4.3-12.3,3.1 c-1.3-0.3-2.5-0.9-3.5-1.7c-0.6,2.4,1.3,4.8,5.2,5.8c4.4,1.2,9.1,0.1,12.3-3.1c1.2-1.7,0.9-4-0.7-5.3 C726.5,448.5,726.3,448.4,726.2,448.3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20860",
    className: "st22",
    d: "M680.7,428.9c5.8-5.1,12.4-9.7,22.6-5.7c-2-4.1-6.8-6.2-11.2-4.8 C686.8,419.8,682.5,423.8,680.7,428.9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20861",
    className: "st22",
    d: "M740.4,412c5.7,0.1,11,3,14.1,7.8c-7-3.7-14.9-6.8-24.8-0.6 C731.1,414.5,735.6,411.5,740.4,412"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20862",
    className: "st6",
    d: "M662.7,404.9l98.8-16.5l-5.3-23.3l-91.8,23.7L662.7,404.9z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20863",
    className: "st5",
    d: "M667.5,463.6c1.1-15.5-17.9-39.9-19.1-20.8C647.9,451.2,666.9,471.9,667.5,463.6"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20864",
    className: "st5",
    d: "M778.1,444c-7.4-13.6,3.3-45,12.2-28.1C794.3,423.3,782.1,451.3,778.1,444"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20865",
    className: "st23",
    d: "M742.6,826.5c-4.9-13-5.9-37.5,5.3-49.6l2.6,2.4c-10,10.9-9,34.1-4.6,45.9L742.6,826.5 z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20866",
    className: "st23",
    d: "M763.4,829.3l-3.6-0.2c0.2-3.8,0.5-7.6,0.8-11.4c1.3-14.6,2.4-28.4-4.6-37l2.8-2.3 c7.9,9.8,6.6,24.9,5.4,39.6C763.9,821.8,763.5,825.6,763.4,829.3"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20867",
    className: "st23",
    d: "M760.2,779.4c0-2.3-3-4.2-6.7-4.2s-6.7,1.9-6.7,4.2s3,4.2,6.7,4.2 S760.2,781.8,760.2,779.4"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20868",
    className: "st2",
    d: "M661,385.2c0.1,0,51.5-18.6,52.9-43.7C716.3,298.7,632.1,372.5,661,385.2"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20869",
    className: "st2",
    d: "M757.4,362.1c-0.1,0.1-51.5,10.3-57.9-5.9C688.5,328.6,777.3,337.7,757.4,362.1"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20870",
    className: "st7",
    d: "M662.7,400.5l100-17.9l-5.4-23.2l-92.9,25L662.7,400.5z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20871",
    className: "st5",
    d: "M494.7,749.1c-1.3,0.9-3.4,2-5.4,3.2c-3.3,1.9-6,5.2-5.3,6.6c0.6,1.1,2.6-1.4,4.9-2.7 c2.2-1.2,2.9-1.7,3.1-1.2c0.2,0.4-2.4,2.5-5,4.8c-3.2,2.8-4.9,5.1-4.2,6.5c0.7,1.3,2.4-1,5.6-3.2c3-2,4.2-3.1,5.1-1.8 c0.5,0.6-1.5,2.2-4,5.2c-2.7,3.3-3.8,6.1-2.9,7c1.3,1.4,1.7-1.1,5.4-4.5c5.2-4.7,5.1-5.5,9.7-5.9c3.4,0.5,3.1,4,7.1,6.7 c2.8-1.6,6.6-23.4,5.3-28C510.6,734.9,507.1,744.9,494.7,749.1"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20872",
    className: "st5",
    d: "M925,272.1c1.5-0.5,3.8-1,6-1.6c3.7-1,7.2-3.5,6.8-4.9c-0.3-1.2-2.8,0.7-5.4,1.4 c-2.4,0.6-3.2,0.9-3.3,0.3c1.9-1.4,3.9-2.5,6.1-3.3c3.8-1.9,3.6-1.7,3.2-3.2c-0.4-1.5-0.1-1.6-3.7-0.3 c-3.4,1.2-4.9,1.9-5.4,0.4c-0.3-0.7,2-1.8,5.2-4c3.5-2.5,1.3-1.9,0.6-3c-0.9-1.7,2-2.4-2.4-0.1c-6.2,3.2-6.6,5.1-11.2,4.3 c-4.7-0.8,6-14.9,2.2-14c-3.1,0.8-19.6,25.4-19.5,30.1C905.9,281.8,912,273,925,272.1"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20873",
    className: "st12",
    d: "M534.5,803.2c8.6-7.6,10.7-19.2,4.8-25.9c-5.9-6.7-17.7-5.9-26.2,1.7 s-10.7,19.2-4.8,25.9C514.2,811.5,525.9,810.8,534.5,803.2"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20874",
    className: "st24",
    d: "M532,801c6.6-5.8,9.3-13.5,6.2-17c-3.2-3.6-11.1-1.8-17.7,4.1 c-6.6,5.8-9.3,13.5-6.2,17C517.5,808.7,525.4,806.8,532,801"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20875",
    className: "st12",
    d: "M912.9,238c10-5.6,14.6-16.4,10.2-24.2s-16-9.6-26-4S882.6,226.2,887,234 C891.3,241.8,902.9,243.6,912.9,238"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20876",
    className: "st13",
    d: "M912.4,236.2c7.9-4.4,12.1-12,9.3-17c-2.8-5-11.4-5.4-19.3-1s-12.1,12-9.3,17 S904.5,240.6,912.4,236.2"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20877",
    className: "st13",
    d: "M939.8,289.2l9-4.6L913.6,225l-9,4.6L939.8,289.2z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20878",
    className: "st12",
    d: "M940.4,290.1l9.1-4.5C934.8,260.2,914.8,244.6,940.4,290.1"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20879",
    className: "st12",
    d: "M955.1,303.1c10-5.6,14.6-16.4,10.2-24.2c-4.3-7.8-16-9.6-26-4 c-10,5.6-14.6,16.4-10.2,24.2C933.4,306.9,945.1,308.7,955.1,303.1"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20880",
    className: "st24",
    d: "M953.1,300.5c7.7-4.3,12-11.1,9.7-15.3c-2.3-4.2-10.4-4.1-18.1,0.2s-12,11.1-9.7,15.3 S945.4,304.8,953.1,300.5"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20881",
    className: "st5",
    d: "M921.1,253.3c2.3-4,3.2-7.8,1.9-8.5c-1.3-0.8-4.2,1.9-6.5,5.8c-2.3,4-3.2,7.8-1.9,8.5 C915.8,259.8,918.7,257.2,921.1,253.3"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20882",
    className: "st5",
    d: "M921.3,251.1c1,3.2,3,5.5,4.4,5c1.4-0.5,1.7-3.4,0.7-6.6c-1-3.2-3-5.5-4.4-5 C920.6,244.9,920.2,247.9,921.3,251.1"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20883",
    className: "st5",
    d: "M930.9,252.6c-1.7,1.2-2.4,3.1-1.5,4.3c1.3,1.2,3.3,1.2,4.6,0c1.7-1.2,2.4-3.1,1.5-4.3 C934.2,251.4,932.2,251.4,930.9,252.6"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20884",
    className: "st5",
    d: "M933.6,258.6c-1.7,1.2-2.4,3.1-1.5,4.3c1.3,1.2,3.3,1.2,4.6,0c1.7-1.2,2.4-3.1,1.5-4.3 C936.9,257.4,934.9,257.4,933.6,258.6"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20885",
    className: "st5",
    d: "M936.3,263.6c-1.7,1.2-2.4,3.1-1.5,4.3c1.3,1.2,3.3,1.2,4.6,0c1.7-1.2,2.4-3.1,1.5-4.3 C939.6,262.4,937.6,262.4,936.3,263.6"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkout);
export default __webpack_public_path__ + "static/media/workout.ea69b00d8e734dc4f3b1e8294321c8d0.svg";
export { ForwardRef as ReactComponent };